/**
 * This constant is used in mixpanel analytics
 * to track user flow to such features as:
 * - Sending a batch message from clinics page
 * - Starting new conversation from clinics page
 */
export const ClinicsAppOrigin = {
    appOrigin: "Clinics",
};
